import React, { useState, useEffect } from "react";
import Select, { createFilter } from "react-select";
import { FixedSizeList as List } from "react-window";
import './SearchSelect.css'
// import "./SeacrhSelect.css";

const SearchSelect = (props) => {
  const {
    name,
    label,
    value,
    errMsg,
    errState,
    optionList,
    labelClass,
    isDisabled,
    placeholder,
    handleSelect,
    errClassName,
    ManualInpValue,
    GetSearchedValue,
  } = props;

  const [inputValue, setInputValue] = useState("");
  const [ValueFromProps, setValueFromProps] = useState(value);
  const [menuHeight, setMenuHeight] = useState(null);

  useEffect(() => {
    if (optionList && optionList.length > 0) {
      const height = name == "tenure" ? 200 : Math.min(optionList.length * 42, 200);
      setMenuHeight(height);
    }
  }, [optionList, inputValue]);
 

  const style1 = {
    control: (base, state) => ({
      ...base,
      height: 52,
      minHeight: 52,
      border: errState
        ? "1px solid #FF464D !important"
        : "1px solid #B1C9FF !important",
      boxShadow: "0 !important",
      "&:hover": {
        border: errState
          ? "1px solid #FF464D !important"
          : "1px solid #B1C9FF !important",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isHovered ? "#F3F7FF" : "transparent",
      color: state.isHovered ? "#000" : "#000",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#F3F7FF",
        color: "#000",
      },
    }),
  };

  const handleInputChange = (inputValue) => {
    GetSearchedValue(inputValue);
    setInputValue(inputValue);
  };

  const VirtualizedMenuList = ({ children, maxHeight, getValue }) => {
    return (
      <List
        height={menuHeight || 200}
        itemCount={optionList?.length}
        itemSize={42}
        width="100%"
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  };


  let filtertenure = ""
  if (name == "tenure") {
    filtertenure = optionList.filter((e) => {
      return e.value != value
    })

  }
  return (
    <>
      <div className="search-select-container">
        <Select
          filterOption={createFilter({ ignoreAccents: false })}
          // menuPlacement="auto"
          options={name == "tenure" ? filtertenure : optionList}
          placeholder={placeholder}
          value={optionList?.find(option => option.value === value) || value ? { value: value, label: value } : []}
          // value={optionList?.filter(function (option) {
          //   return option.value === value;
          // })}
          name={name}
          onChange={handleSelect}
          isSearchable={true}
          styles={style1}
          isDisabled={isDisabled ? isDisabled : false}
          onInputChange={GetSearchedValue ? handleInputChange : ""}
          components={{ MenuList: VirtualizedMenuList }}
        // defaultMenuIsOpen={true} // to set options open byDefault
        />
        {errMsg ? <p className="err-msg"> {errMsg} </p> : ""}
        {value && label ? (
          <p
            className={
              labelClass
                ? labelClass + " label-dropdown label-dropdown-search"
                : "label-dropdown label-dropdown-search"
            }
          >
            {label}
          </p>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default SearchSelect;
